/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AuthGuard } from '@core/guards/auth/auth.guard';
import { Routes } from '@angular/router';

export const mainRoutes: Routes = [
  {
    path: 'logon',
    loadChildren: () =>
      import('../pages/logon/logon.module').then(m => m.LogonPageModule)
  },
  {
    path: 'activate',
    loadChildren: () =>
      import('../pages/activate/activate.module').then(
        m => m.ActivatePageModule
      )
  },
  {
    path: 'exit',
    loadChildren: () =>
      import('../pages/exit/exit.module').then(m => m.ExitPageModule)
  },
  {
    path: 'position',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../pages/position/position.module').then(
        m => m.PositionPageModule
      )
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('../pages/settings/settings.module').then(
        m => m.SettingsPageModule
      )
  },
  {
    path: 'error',
    loadChildren: () =>
      import('../pages/error/error.module').then(m => m.ErrorPageModule)
  },
  {
    path: 'exit',
    loadChildren: () =>
      import('../pages/exit/exit.module').then(m => m.ExitPageModule)
  },
  {
    path: '',
    redirectTo: 'logon',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'error/404',
    pathMatch: 'full'
  }
];
